import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import App from './App'
import config from './config'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const rootElement = document.getElementById('root')

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Helmet>
      <title>{config.appName}</title>
    </Helmet>
    <App />
  </BrowserRouter>,
  rootElement
)
